import { AccountCategory, ChartOfAccountsAccount, COAAccountNode, COAGroup } from '@futrli-sdk/predict';

export enum ActiveMode {
  REORDERING = 'reordering',
  RECLASSIFYING = 'reclassifying',
  CREATE_GROUP = 'create-group'
}

export const ROOT = 'ROOT';

export const P_AND_L_CATEGORIES: AccountCategory[] = [
  AccountCategory.income,
  AccountCategory.cost_of_sales,
  AccountCategory.expenses,
  AccountCategory.other_income,
  AccountCategory.other_expenses
];

export const BALANCE_SHEET_CATEGORIES: AccountCategory[] = [
  AccountCategory.bank_accounts,
  AccountCategory.fixed_assets,
  AccountCategory.current_assets,
  AccountCategory.non_current_assets,
  AccountCategory.current_liabilities,
  AccountCategory.non_current_liabilities,
  AccountCategory.equity
];

export const ASSET_CATEGORIES: AccountCategory[] = [
  AccountCategory.current_assets,
  AccountCategory.non_current_assets,
  AccountCategory.fixed_assets,
  AccountCategory.bank_accounts
];

export const LIABILITY_CATEGORIES: AccountCategory[] = [
  AccountCategory.current_liabilities,
  AccountCategory.non_current_liabilities
];

export const SWITCH_RULE_CATEGORIES = [...ASSET_CATEGORIES, ...LIABILITY_CATEGORIES];

export interface CreateGroupPayload extends Omit<COAGroup, 'category'> {
  category: string;
}

export enum COA_TYPE {
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  BALANCE_SHEET = 'BALANCE_SHEET'
}

export interface COAUpdateCategory {
  type: string;
  category: string;
  children: COADisplayAccount[];
}

export interface COAUpdateFullStructurePayload {
  readonly profit_and_loss: COAUpdateCategory[];
  readonly balance_sheet: COAUpdateCategory[];
}

export interface COADisplayAccount
  extends Omit<COAAccountNode, 'type' | 'category' | 'switch_rule_category' | 'year_to_date' | 'days_to_pay'> {
  type: string;
  children: COADisplayAccount[];
  category: string;
  depth?: number;
  parentId?: string;
  switch_rule_category?: string | null;
  year_to_date?: string | null;
  days_to_pay?: number | null;
}

export interface COARecategoriseAccountPayload {
  account_id: string;
  to_category: string;
}

export interface COASwitchRulePayload {
  category: string;
}

export interface ChartOfAccountsDisplay extends ChartOfAccountsAccount {
  id: string;
}
